﻿import {hasFlag, translation} from "@2d-front-monorepo/core";
import {
	AttachmentsComponent,
	EntityHistoryStatusComponent,
	PermitFullEntityResult, RequiredVehicleProperties, VehicleId,
	VehicleResult
} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {API_ENDPOINT} from "../../../api-endpoint";
import { JSX } from "react";

const filesPrefix = API_ENDPOINT.fileDownload;

export function VehicleComponent({vehicle, hiddenEntityProperties, showStatus}: { vehicle: PermitFullEntityResult<VehicleId, VehicleResult>,hiddenEntityProperties: RequiredVehicleProperties, showStatus: boolean }):JSX.Element {
	const data = vehicle.entity.data;
	return <>
		<div className="layout horizontal aligned middle card--vehicle__header">
			<h6 className="flex">{translation(PermitTranslations.vehicle__plate)} [<span>{vehicle.entity.plate}</span>]</h6>
			{showStatus && <EntityHistoryStatusComponent status={vehicle} />}
		</div>
		<hr/>
		<div className="columns gap padded">
			<div className="col75 columns gap">
				{!hasFlag(hiddenEntityProperties, RequiredVehicleProperties.Nickname) &&
				<dl className="title-desc col33">
					<dt>{translation(PermitTranslations.vehicle__nickname)}</dt>
					<dd>{data?.nickname}</dd>
				</dl>}
				{!hasFlag(hiddenEntityProperties, RequiredVehicleProperties.Model) &&
				<dl className="title-desc col33">
					<dt>{translation(PermitTranslations.vehicle__model)}</dt>
					<dd>{data?.model}</dd>
				</dl>}
				{!hasFlag(hiddenEntityProperties, RequiredVehicleProperties.Color) &&
				<dl className="title-desc col33">
					<dt>{translation(PermitTranslations.vehicle__color)}</dt>
					<dd>{data?.color}</dd>
				</dl>}
				{!hasFlag(hiddenEntityProperties, RequiredVehicleProperties.Type) &&
				<dl className="title-desc col33">
					<dt>{translation(PermitTranslations.vehicle__type)}</dt>
					<dd>{data?.type}</dd>
				</dl>}
				{!hasFlag(hiddenEntityProperties, RequiredVehicleProperties.Province) &&
				<dl className="title-desc col33">
					<dt>{translation(PermitTranslations.vehicle__province)}</dt>
					<dd>{data?.province}</dd>
				</dl>}
			</div>
			<AttachmentsComponent entity={vehicle.entity} linkPrefix={filesPrefix} className="col25"/>
		</div>
	</>;
}
